import React, { useEffect, useId, useState } from 'react';
import { formatDate, parseToDate, toIsoDate } from '../utils/dates';
import './DateInput.css';

/**
 * Date field that displays DD/MM/YYYY and stores YYYY-MM-DD for the API.
 */
const DateInput = ({
  id,
  value = '',
  onChange,
  required = false,
  disabled = false,
  className = '',
  name,
  placeholder = 'DD/MM/YYYY'
}) => {
  const autoId = useId();
  const inputId = id || autoId;
  const isoValue = toIsoDate(value);
  const [text, setText] = useState(isoValue ? formatDate(isoValue, '') : '');

  useEffect(() => {
    setText(isoValue ? formatDate(isoValue, '') : '');
  }, [isoValue]);

  const emitIso = (iso) => {
    if (typeof onChange === 'function') {
      onChange({
        target: {
          value: iso,
          name: name || undefined
        }
      });
    }
  };

  const commitText = (raw) => {
    const trimmed = String(raw || '').trim();
    if (!trimmed) {
      setText('');
      emitIso('');
      return;
    }
    const d = parseToDate(trimmed);
    if (!d) {
      setText(isoValue ? formatDate(isoValue, '') : '');
      return;
    }
    const iso = toIsoDate(d);
    setText(formatDate(iso, ''));
    emitIso(iso);
  };

  return (
    <div className={`date-input ${className}`.trim()}>
      <input
        id={inputId}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        placeholder={placeholder}
        value={text}
        disabled={disabled}
        required={required && !isoValue}
        onChange={(e) => setText(e.target.value)}
        onBlur={(e) => commitText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            commitText(e.target.value);
          }
        }}
      />
      <input
        type="date"
        className="date-input-native"
        value={isoValue}
        disabled={disabled}
        tabIndex={-1}
        aria-hidden="true"
        onChange={(e) => {
          const iso = e.target.value;
          setText(iso ? formatDate(iso, '') : '');
          emitIso(iso);
        }}
      />
    </div>
  );
};

export default DateInput;
